import { observer } from "mobx-react";
import * as React from "react";
import { TypeAheadSearchInput } from "../General/TypeAheadSearchInput";
import { LinkIcon } from "../Icons/LinkIcon";
import { Strings } from "../Stores/StringsStore";
import { Urls } from "../Urls";
import { Link } from "./Link";

@observer
export class TileNavigation extends React.Component<{}, {}> {

	render() {
		return <div className="tile-nav" >

			<div className="tile-nav__primary">

				<Link to={Urls.search} testId="searchLink">
					<h2>{Strings.homepage.searchDocumentsTitle}</h2>
					<span>
						<LinkIcon />
					</span>
				</Link>

				<div className="tile-nav__primary-search">
					<TypeAheadSearchInput placeholder={Strings.homepage.searchPlaceholder} preventSearchOnClear={true} isDirectSearch={true} />
				</div>

			</div>

			<div className="tile-nav__secondary">
				<Link to={Urls.favorites} testId="favouritesLink">
					<h2>{Strings.homepage.favouriteDocumentsTitle}</h2>
					<span>
						<LinkIcon />
					</span>
				</Link>
			</div>

		</div>;
	}
}
